import { Component } from '@angular/core';
import { LoginService } from '../app/security/login.service';
import { NavigationStart, Router } from '@angular/router';
import { UserService } from './service/user.service';
import { NavigationService } from './service/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'frontend4';

  constructor(
    public loginService: LoginService,
    private router: Router,
    private userService: UserService,
    private navigationService: NavigationService
  ) {
    //reset the user roles and menus (detect routerlink transition)
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url.startsWith("/management") && this.isPageReload()) {
                        console.log("app component line 25");
          if (localStorage.getItem("isConnected") === "true") {
            this.userService.updateUserInfo().subscribe(() => {

              this.navigationService.setItems();
            }, error => {
                                      console.log("app component line 31");
              console.error(error);
            });
          }
        }
      }
    });
    //handle normal page load
                            console.log("app component line 39");
    if (localStorage.getItem("isConnected") === "true") {
      this.userService.updateUserInfo().subscribe(() => {
        this.navigationService.setItems();
      }, error => {
                                console.log("app component line 44");
        console.error(error);
      });
    }
  }

  isPageReload() {
    const navigations = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    return navigations[0] && navigations[0].type === "reload";
  }
}